export default "__VITE_ASSET__46e9588b__"